










export default defineComponent({
  setup() {
    const root = ref<Vue>((null as any) as Vue);
    const hasHeader = ref(false);
    const hasFooter = ref(false);

    watch(
      () => root.value?.$children || [],
      children => {
        hasHeader.value = !!children
          .map(c => c.$el)
          .find(el => el.classList.contains("page__header"));
        hasFooter.value = !!children
          .map(c => c.$el)
          .find(el => el.classList.contains("page__footer"));
      },
      {
        immediate: true,
        deep: true
      }
    );

    return {
      root,
      hasHeader,
      hasFooter
    };
  }
});
import { defineComponent, ref, watch } from "@vue/composition-api";
